import DOMPurify from "dompurify";
import { LitElement, css, html } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { shared } from "../../styles";

@customElement("ptc-rich-content")
export class RichContent extends LitElement {
    @property()
    content: string;

    @property({ type: Number })
    previewHeight?: number;

    @property({ type: Boolean })
    expanded = false;

    @state()
    private _innerHeight: number = 0;

    @query(".inner")
    private _inner: HTMLDivElement;

    updated() {
        this.style.maxHeight = this.previewHeight && !this.expanded ? `${this.previewHeight}px` : "none";
        this._innerHeight = this._inner.offsetHeight;
        this._inner.style.paddingBottom = this.previewHeight && this.previewHeight < this._innerHeight ? "1.5em" : "0";
    }

    static styles = [
        shared,
        css`
            :host {
                display: block;
                position: relative;
                cursor: text;
                overflow: hidden;
            }

            ul {
                list-style: disc outside;
                padding-left: 1em;
            }

            h1,
            h2,
            h3,
            h4 {
                margin: 0 0 0.5em 0;
            }

            h1:not(:first-child),
            h2:not(:first-child),
            h3:not(:first-child),
            h4:not(:first-child) {
                margin-top: 0.5em;
            }

            p {
                margin: 0.5em 0;
            }

            p:first-child {
                margin-top: 0;
            }

            p:last-child {
                margin-bottom: 0;
            }

            em {
                font-style: italic;
            }

            .show-more {
                position: absolute;
                bottom: -1em;
                left: 0;
                right: 0;
                cursor: pointer;
                background: var(--color-bg);
                border-top: solid 1px var(--shade-2);
            }

            .show-more button {
                background: var(--color-bg);
                position: relative;
                top: -1em;
            }
        `,
    ];

    render() {
        return html`
            <div class="inner">${unsafeHTML(DOMPurify.sanitize(this.content))}</div>
            ${!this.previewHeight || this.previewHeight > this._innerHeight
                ? ""
                : !this.expanded
                  ? html`
                        <div class="show-more horizontal layout">
                            <div class="stretch"></div>
                            <button class="skinny" @click=${() => (this.expanded = true)}>
                                <ptc-ui-icon name="icon.toggle.show-more"></ptc-ui-icon> Mehr Anzeigen
                                <ptc-ui-icon name="icon.toggle.show-more"></ptc-ui-icon>
                            </button>
                            <div class="stretch"></div>
                        </div>
                    `
                  : html`
                        <div class="show-more horizontal layout">
                            <div class="stretch"></div>
                            <button class="skinny" @click=${() => (this.expanded = false)}>
                                <ptc-ui-icon name="icon.toggle.show-less"></ptc-ui-icon> Weniger Anzeigen
                                <ptc-ui-icon name="icon.toggle.show-less"></ptc-ui-icon>
                            </button>
                            <div class="stretch"></div>
                        </div>
                    `}
        `;
    }
}
